import React, { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import {
  FormInput,
  FormsSelect,
  FormTemplate,
} from "../../../../dashboard/Components/Forms/InputTemplate";
import FormUploadComponent from "../../../../dashboard/Components/Forms/FormUploadComponent";
import { TableActionsDownload } from "../../../../dashboard/Components/Misc/ActionsModVersion";
import { removeListData } from "../../../../../utils/functions/ResourceFunctions";
import {
  CreateApplicant,
  GetDocumentDifinition,
  UploadAppilcantMedicalForm,
} from "../../../../../utils/redux/HR/HRSlice";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "../../../Components/Layout/PageLayout";
import Table from "../../../Components/Table/Table";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import axios from "axios";

function UploadMedicalForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const documentList = useSelector(
    (state) => state?.hr?.document_definition?.result
  );
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  console.log("id", id);

  const pathArray = window.location.pathname.split("/");
  const jobIdIndex =
    pathArray.findIndex((item) => item === "job-application") + 1;
  const jobId = pathArray[jobIdIndex];
  console.log("Job ID:", jobId);

  const [uploadFile, setUploadFile] = useState(null);
  const [documents, setDocuments] = useState([]);
  const formMethods = useForm({ mode: "all" });

  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods;

  console.log("documents", documents, documentList);

  const submit = async () => {
    const formData = new FormData();

    // Ensure that applicantId is sent as a number (convert and check)
    formData.append("applicantId", String(Number(id))); // Force string conversion to make sure it's a valid number

    documents.forEach((document, index) => {
      // Get the correct document definition from documentList
      const definition = documentList.find(
        (item) => item.name === document.fileName
      );

      if (definition) {
        // Ensure id and definitionId are passed as numbers (convert them before appending)
        formData.append(
          `documents[${index}].id`,
          String(Number(definition.id)) // Force number conversion
        );
        formData.append(
          `documents[${index}].definitionId`,
          String(Number(definition.id)) // Force number conversion
        );
      } else {
        // If no definition found, append null or handle error
        formData.append(`documents[${index}].id`, null);
        formData.append(`documents[${index}].definitionId`, null);
      }

      // Append the file as is (it should already be a valid File object)
      formData.append(
        `documents[${index}].file`,
        document.file,
        document.file?.name
      );
    });

    try {
      setLoading(true);
      const res = await dispatch(UploadAppilcantMedicalForm(formData)); // Use correct action name
      if (res.payload.successful) {
        toast.success(res.payload.statusMessage);
        setLoading(false);
        // reset();
        navigate("/dashboard/hr/recruitment-service/14/view?status=approval&type=MD");  // Optionally navigate or reset
      } else {
        toast.error(res.payload.statusMessage);
        setLoading(false);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("An error occurred. Please try again");
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(
      GetDocumentDifinition({
        pageNumber: 1,
        pageSize: 10,
        Module: 18,
        Search: "Medical",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-7xl mx-auto my-10 p-6">
      <PageLayout title={"Upload Medicals"} hasBack={true}>
        <FormProvider {...formMethods}>
          <FormTemplate handleSubmit={handleSubmit(submit)}>
            {/* Upload Supporting Documents Section */}
            <section className={DashboardStyle.form_section}>
              <h4 className={DashboardStyle.form_section_title}>
                Upload Supporting Documents
              </h4>
              <FormUploadComponent
                documentList={documentList}
                uploadFile={uploadFile}
                setUploadFile={setUploadFile}
                setVendorDocument={setDocuments}
                vendorDocument={documents}
                isOptional={false}
              />
            </section>

            {/* Uploaded Documents Section */}
            <section className={DashboardStyle.form_section}>
              <h4 className={DashboardStyle.form_section_title}>
                Documents Uploads
              </h4>
              <section
                className={`${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads}`}
              >
                {documents.length === 0 ? (
                  <p>No Record Available</p>
                ) : (
                  <Table className={DashboardStyle.table}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>File Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documents.map(
                        (doc, index) => (
                          console.log("Document:", doc)
                          (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{doc.name}</td>
                              <td>
                                <TableActionsDownload
                                  file={doc.file || null}
                                  url={doc.fileUrl || null}
                                  actions={() =>
                                    removeListData({
                                      value: index,
                                      list: documents,
                                      setList: setDocuments,
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  </Table>
                )}
              </section>
            </section>
            {/* Form Actions */}
            <div className={DashboardStyle.button_cage}>
              <SupportButtons
                type="button"
                onClick={() => reset()}
                className="px-6 py-2 bg-gray-100 text-gray-800 border border-gray-300 rounded-md"
              >
                Save as Draft
              </SupportButtons>
              <ActionButtons
                type="submit"
                disabled={!documents.length}
                className="px-6 py-2 bg-green-600 text-white rounded-md"
              >
                {loading ? "Processing..." : "Upload Medicals"}
              </ActionButtons>
            </div>
          </FormTemplate>
        </FormProvider>
      </PageLayout>
    </div>
  );
}

export default UploadMedicalForm;
